import { render, staticRenderFns } from "./LoginWithGoogle.vue?vue&type=template&id=05d5575e&scoped=true"
import script from "./LoginWithGoogle.vue?vue&type=script&lang=js"
export * from "./LoginWithGoogle.vue?vue&type=script&lang=js"
import style0 from "./LoginWithGoogle.vue?vue&type=style&index=0&id=05d5575e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d5575e",
  null
  
)

export default component.exports